/**
 * Role → module access map (client copy). Mirrors server/permissions.ts —
 * keep the two in sync. Drives sidebar visibility and route guards.
 */
export type ModuleKey =
  | 'dashboard' | 'students' | 'leads' | 'applications' | 'institutions' | 'visa'
  | 'documents' | 'finance' | 'appointments' | 'tasks' | 'team' | 'hr' | 'payroll'
  | 'activity' | 'reports' | 'subscription' | 'settings';

const DEFAULT_STAFF: ModuleKey[] = ['dashboard', 'students', 'leads', 'applications', 'institutions', 'visa', 'documents', 'appointments', 'tasks', 'reports', 'settings'];

export const ROLE_MODULES: Record<string, ModuleKey[] | '*'> = {
  Owner: '*',
  Manager: ['dashboard', 'students', 'leads', 'applications', 'institutions', 'visa', 'documents', 'finance', 'appointments', 'tasks', 'team', 'hr', 'payroll', 'activity', 'reports', 'settings'],
  Counselor: ['dashboard', 'students', 'leads', 'applications', 'institutions', 'visa', 'documents', 'appointments', 'tasks', 'reports', 'settings'],
  'Visa Officer': ['dashboard', 'applications', 'visa', 'documents', 'institutions', 'appointments', 'tasks', 'reports', 'settings'],
  Accountant: ['dashboard', 'finance', 'payroll', 'reports', 'students', 'settings'],
  'Front Desk': ['dashboard', 'leads', 'appointments', 'students', 'settings'],
};

export function modulesForRole(role: string | undefined | null): ModuleKey[] | '*' {
  if (!role) return DEFAULT_STAFF;
  return ROLE_MODULES[role] ?? DEFAULT_STAFF;
}

export function canAccess(role: string | undefined | null, module: ModuleKey): boolean {
  const mods = modulesForRole(role);
  return mods === '*' || mods.includes(module);
}
